<template>
    <svg
        width="102"
        height="14"
        viewBox="0 0 102 14"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.6328 13.7949H24.3983V11.2196H17.5841V8.06089H23.2338V5.48339H17.5841V2.57534H24.4394V0H14.6328V13.7949Z"
        />
        <path
            d="M36.1541 8.68312L29.7569 0H25.3516L26.7235 1.7457V13.8381H29.6726V4.77906L36.2795 13.7949H39.1054V0H36.1541V8.68312Z"
        />
        <path
            d="M10.1804 6.6976C11.4767 6.44914 12.5569 5.24357 12.5569 3.54109C12.5483 1.70249 11.2196 0 8.55997 0H0L1.32872 1.70249V13.8014H8.85812C11.5199 13.8014 12.8896 12.1399 12.8896 10.0615C12.84 8.35256 11.6668 6.89853 10.1804 6.6976ZM4.27998 2.59262H7.97879C8.97695 2.59262 9.59918 3.17596 9.59918 4.04665C9.59918 4.91734 8.97695 5.50068 7.97879 5.50068H4.27998V2.59262ZM8.10194 11.2347H4.27998V8.06089H8.10194C9.22541 8.06089 9.84764 8.76738 9.84764 9.64023C9.84764 10.6362 9.1822 11.2196 8.10194 11.2196V11.2347Z"
        />
        <path
            d="M82.2726 8.68312H83.8109V10.3057C83.0152 10.9644 82.0178 11.3304 80.9849 11.3427C78.5327 11.3427 76.7892 9.47387 76.7892 6.93958C76.7892 4.40529 78.5327 2.53429 80.9849 2.53429C81.6151 2.5395 82.234 2.70189 82.7856 3.00672C83.3371 3.31154 83.8039 3.74919 84.1436 4.27998L86.4705 2.98367C85.4745 1.41298 83.7266 0 80.9439 0C77.0377 0 73.7969 2.70065 73.7969 6.89853C73.7969 11.0964 76.9966 13.7949 80.9439 13.7949C82.0099 13.8126 83.067 13.5988 84.0424 13.1684C85.0178 12.738 85.8882 12.1011 86.5936 11.3017V6.19204H80.2784L82.2726 8.68312Z"
        />
        <path
            d="M68.9766 8.68312L62.5772 0H58.1719L59.5438 1.7457V13.8381H62.4951V4.77906L69.1019 13.7949H71.9257V0H68.9766V8.68312Z"
        />
        <path
            d="M96.3576 0H90.6668L92.0366 1.7457L91.7881 2.40898L87.3828 13.8381H90.7079L91.5721 11.5091H97.5243L98.3885 13.8381H101.711L96.3576 0ZM92.3304 8.89269L94.4909 2.9491L96.6514 8.89269H92.3304Z"
        />
        <path d="M56.4669 0H53.5156V13.8381H56.4669V0Z" />
        <path
            d="M51.1555 2.36793V0H40.7656V2.57534H47.2904L40.7656 11.427V13.7949H51.2809V11.2196H44.5897L51.1555 2.36793Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'Benzinga'
};
</script>
